// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/utils/PackageCardsHandlers.js
import { API_URLS } from '../api/api';

export const fetchStatusOptions = async (setStatusOptions, setIsLoadingStatus, setToastMessage, setToastVariant, setShowToast) => {
  setIsLoadingStatus(true);
  try {
    const response = await fetch(API_URLS.STATUS_LIST, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch status list');
    }
    const data = await response.json();
    const options = data.map(status => ({
      value: status.id,
      label: status.name,
    }));
    setStatusOptions(options);
  } catch (error) {
    console.warn('Error fetching status options:', error.message);
    setToastMessage('Failed to load status options');
    setToastVariant('error');
    setShowToast(true);
  } finally {
    setIsLoadingStatus(false);
  }
};

export const handleStatusChange = async (pkg, statusId, userId, setToastMessage, setToastVariant, setShowToast, statusOptions) => {
  if (!userId) {
    setToastMessage('User ID is missing. Status update is disabled.');
    setToastVariant('error');
    setShowToast(true);
    return false;
  }

  const token = localStorage.getItem('token');
  if (!token) {
    setToastMessage('No authentication token found. Please log in.');
    setToastVariant('error');
    setShowToast(true);
    return false;
  }

  try {
    const response = await fetch(API_URLS.PACKAGE_UPDATE, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        package_id: pkg.package_id,
        user_id: userId,
        status_ID: statusId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to update package status');
    }

    const data = await response.json();
    setToastMessage('Package status updated successfully');
    setToastVariant('success');
    setShowToast(true);

    // Update local package data
    pkg.status_ID = statusId;
    pkg.status_name = statusOptions.find(option => option.value === statusId)?.label || pkg.status_name;
    return true;
  } catch (error) {
    console.warn('Error updating package status:', error.message);
    setToastMessage(error.message || 'Failed to update package status');
    setToastVariant('error');
    setShowToast(true);
    return false;
  }
};